var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    viewBox: "0 0 66 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.504 16.0684V7.59241V7.12152L32.744 1L64.488 18.4228V29.2532L54.248 35.3747L48.616 32.5494L43.496 35.3747L42.984 43.3797L56.296 35.8456L64.488 40.5544L65 52.3266L32.744 68.8076L21.992 63.157L22.504 52.3266L27.624 49.5013V43.3797L11.752 35.3747L20.456 40.5544V53.2684L11.24 57.9772L1 51.8557L1.512 17.9519L11.752 12.3013L21.992 18.4228C21.992 18.4228 21.6894 21.5185 21.992 22.6608C22.0493 22.8772 22.0298 23.0286 21.9709 23.1317C21.8491 23.3449 21.559 23.3519 21.4325 23.3023L27.624 26.8987L34.4685 22.912C33.9565 22.912 22.504 16.5392 22.504 16.5392V16.0684Z",
    fill: "#6D00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.504 16.0684V7.59241L42.984 17.9519L35.304 22.4253L27.624 26.8987L17.896 21.2481L21.992 18.4228M22.504 16.0684V7.12152L32.744 1L64.488 18.4228M22.504 16.0684V16.5392C22.504 16.5392 33.9565 22.912 34.4685 22.912M21.992 18.4228C21.992 18.4228 21.6894 21.5185 21.992 22.6608C22.2946 23.8031 20.456 23.1316 21.992 23.1316M21.992 18.4228L11.752 12.3013L1.512 17.9519M1.512 17.9519L1 51.8557L11.24 57.9772M1.512 17.9519L17.128 26.4278L32.744 34.9038M11.24 57.9772L20.456 53.2684V40.5544L11.752 35.3747M11.24 57.9772L11.752 35.3747M11.752 35.3747L27.624 43.3797V49.5013L22.504 52.3266L21.992 63.157L32.744 68.8076M32.744 68.8076L65 52.3266L64.488 40.5544M32.744 68.8076V34.9038M64.488 40.5544L56.296 35.8456L42.984 43.3797M64.488 40.5544L43.496 52.3266L42.984 43.3797M42.984 43.3797L43.496 35.3747L48.616 32.5494L54.248 35.3747L64.488 29.2532V18.4228M64.488 18.4228L32.744 34.9038",
    stroke: "black",
    strokeOpacity: 0.48,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXm);
export default __webpack_public_path__ + "static/media/xm.67cdfeb1ac9e073e5c7020642d2892c3.svg";
export { ForwardRef as ReactComponent };